import React, { Component, useEffect, useState } from "react";
import ReactDOM from "react-dom";
import "../css/winner-slider.css";
import FlickitySlider from "./FlickitySlider";
import WinnerSliderItem from "./WinnerSliderItem";
import axios from "axios";

function WinnerSlider({ id }) {
  const [theWinners, setWinners] = useState([]);

  useEffect(() => {
    axios.get("/w/api/" + id + "/leaderboard").then((response) => {
      let lb = [];
      let k;
      response.data.leaderboard.forEach((item) => {
        if (k === undefined) {
          k = {
            date: item.date,
            winners: [],
          };
        } else if (k.date !== item.date) {
          lb.push(k);
          k = {
            date: item.date,
            winners: [],
          };
        }
        k.winners.push(item.msisdn);
      });
      if (k != null) {
        lb.push(k);
      }

      setWinners(lb);
    });
  }, []);

  if (theWinners.length === 0) return <></>;
  return (
    <>
      <div className="winner-slider">
        <div className="winner-slider-a">List Pemenang Hadiah Pulsa</div>
        <FlickitySlider
          options={{
            prevNextButtons: false,
            pageDots: true,
          }}
        >
          {theWinners.map((data, index) => (
            <WinnerSliderItem
              key={index}
              date={data.date}
              winners={data.winners}
            />
          ))}
        </FlickitySlider>
      </div>
    </>
  );
}

export default WinnerSlider;
